const selectors = ({ store }) => ({
    isOpen: (state, { actionKey }) => state[store].modals[actionKey] || false,
    actionPending: (state) => state[store].actionPending,
    actionReady: (state) => state[store].actionReady,
    actionFinished: (state) => state[store].actionFinished
})

export default selectors
